import { toysubContactUsUrl, toranaToyShindanUrl, toranaPlanExampleUrl } from "@/configs/externalUrls";
import { SettingsItemTemplate } from "@/pages/settings/__components__/SettingsItemTemplate";
import { useSignOut } from "@/hooks/useSignOut";
import { type FC } from "react";
import { othersSettingsTestId } from "./const";
import { datadogLogs } from "@datadog/browser-logs";
import { useCustomerContentPolicy } from "@/hooks/useCustomerContentPolicy";

export const OthersSettings: FC = () => {
  const signOut = useSignOut();
  const { isBabyRental } = useCustomerContentPolicy();

  return (
    <SettingsItemTemplate
      data-testid={othersSettingsTestId}
      title="その他"
      items={[
        ...(!isBabyRental
          ? [
              {
                icon: "piggyBank" as const,
                text: "年齢別おすすめおもちゃ一例",
                href: toranaPlanExampleUrl,
                target: "_blank" as const,
                rel: "noopener norefferer",
              },
              {
                icon: "book" as const,
                text: "おもちゃ診断",
                href: toranaToyShindanUrl,
                target: "_blank" as const,
                rel: "noopener norefferer",
              },
            ]
          : []),
        {
          icon: "envelope",
          text: "お問い合わせ",
          href: toysubContactUsUrl,
          target: "_blank",
          rel: "noopener norefferer",
        },
        // sign out
        {
          icon: "signOutAlt",
          text: "サインアウト",
          handleClick: () => {
            // biome-ignore lint/complexity/noVoid :[AUTOMATICALLY-INSERTED] The use of void is not allowed.
            void signOut();
            datadogLogs.clearUser();
          },
        },
      ]}
    />
  );
};
